import HttpWrapper from '@/utils/http/httpWrapper'

import ShipbobAppSettings from '../../appSettings/appSetting'

export const SHIPPING_SERVICE_API = ShipbobAppSettings.ShippingServiceApiUrl + '/api/v1/'

class ShipOptionsServiceInternal {
  urls () {
    return {
      getShippingServices: SHIPPING_SERVICE_API + 'ShippingService'
    }
  }

  async getShippingServices () {
    const request = {
      Url: `${this.urls().getShippingServices}?includeInactive=true`
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  async getActiveShippingServices () {
    const request = {
      Url: `${this.urls().getShippingServices}?includeInactive=false`
    }
    return await HttpWrapper.Get(request, null, null, true)
  }

  async getShippingServicesByOrderId (orderId) {
    const request = {
      Url: `${this.urls().getShippingServices}?orderId=${orderId}`
    }
    return await HttpWrapper.Get(request, null, null, true)
  }
}

export const ShipOptionsService = new ShipOptionsServiceInternal()
